import * as mutation_types from "./mutation_types";

export default {
    [mutation_types.M_SET_SEARCHED](state, payload) {
        state.searched = payload;
    },
    [mutation_types.M_SET_DATE](state, payload) {
        state.cashSearchResult = payload;
    },
    [mutation_types.M_SET_DIRECT](state, payload) {
        state.direct = payload;
    },
    [mutation_types.M_SET_API_URL](state, payload) {
        state.API_URL = payload;
    },
    [mutation_types.M_SET_API_ORIGIN](state, payload) {
        state.API_ORIGIN = payload;
    },
    [mutation_types.M_SET_AVIA_QUOTA_FOR_TICKETS](state, payload) {
        state.aviaQuota = payload;
    }
};
